<template>
  <div class="tipo-campanha-cards">
    <div
      v-for="(grupo, grupoKey) in gruposOrdenados"
      :key="grupoKey"
      class="tipo-campanha-cards__grupo"
    >
      <div class="tipo-campanha-cards__grupo-label">{{ grupo.label }}</div>
      <div class="tipo-campanha-cards__grid">
        <SelectableCard
          v-for="opcao in grupo.opcoes"
          :key="opcao.codigo"
          :value="opcao.codigo"
          :label="opcao.short"
          :description="opcao.full"
          :help="opcao.help"
          :icon="opcao.icon"
          :selected="value === opcao.codigo"
          :disabled="disabled"
          @select="$emit('input', $event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SelectableCard from "./SelectableCard.vue";
import { VALIDACAO_LABELS, VALIDACAO_GRUPOS } from "../helpers/campanhaLabels";

export default {
  name: "TipoCampanhaCards",
  components: { SelectableCard },
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    gruposOrdenados() {
      const grupos = {};

      Object.entries(VALIDACAO_LABELS).forEach(([codigo, config]) => {
        const grupoKey = config.grupo;
        if (!grupos[grupoKey]) {
          grupos[grupoKey] = {
            label: VALIDACAO_GRUPOS[grupoKey].label,
            ordem: VALIDACAO_GRUPOS[grupoKey].ordem,
            opcoes: [],
          };
        }
        grupos[grupoKey].opcoes.push({ codigo, ...config });
      });

      return Object.values(grupos).sort((a, b) => a.ordem - b.ordem);
    },
  },
};
</script>

<style scoped>
.tipo-campanha-cards__grupo {
  margin-bottom: 10px;
}

.tipo-campanha-cards__grupo:last-child {
  margin-bottom: 0;
}

.tipo-campanha-cards__grupo-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.tipo-campanha-cards__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

@media (max-width: 992px) {
  .tipo-campanha-cards__grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .tipo-campanha-cards__grid {
    grid-template-columns: 1fr;
  }
}
</style>
